<template>
    <project-step-container
            prev-to="be_deep_customer_empathy_4"
            :on-discard-project="redirection"
            :on-keep-version-project="redirection"
            @next-click="updateProject"
    >   
        <b-row>
            <b-col class="text-center" cols="12">
                <img width="85%" src="../Images/students-meeting.jpg" tabindex="0"
                     alt="Students having a meeting or discussion.">
            </b-col>  
            <b-col  cols="12"  class="mt-4 main-text" tabindex="0" >
                {{getMessage(5, 'empathy-map-sub')}}           
            </b-col>       
        </b-row>
   
        <b-row class="mt-3">
            <b-col cols="12" class="mt-3">
                <label for="first-thing">{{getMessage(5, 'firstThing')}}</label>
                <input id="first-thing" type="text" v-model="form.firstThing"/>
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="second-thing">{{getMessage(5, 'secondThing')}}</label>
                <input id="second-thing" type="text" v-model="form.secondThing"/>
            </b-col>
            <b-col cols="12" class="mt-3">
                <label for="third-thing">{{getMessage(5, 'thirdThing')}}</label>
                <input id="third-thing" type="text" v-model="form.thirdThing"/>
            </b-col>
        </b-row>
    </project-step-container>
</template>

<script>
    import Steps from "../Utils/steps";
    import {Storage, Project, ConflictSyn} from "../../../core/Utils"
    import ProjectStepContainer from "../../../core/Components/ProjectStepContainer"

    export default {
        name: "DeepCustomerEmpathy5",
        components: {ProjectStepContainer},
        data() {
            return {
                step: Steps.FORM_THINGS_LEARNED,
                urlNextProject:'be_deep_customer_empathy_6',
                form: {
                    firstThing: "",
                    secondThing: "",
                    thirdThing: ""
                },
            }
        },
        mounted() {
            const forms = Storage.getProjectForms(this.$route.params.index)
            if (this.step in forms) this.form = forms[this.step]
        },
        methods: {
            updateProject() {
                const stepNumber = Steps.getStepFromForm(this.step)
                const index = this.$route.params.index
                Project.saveProjectStep(index, this.step, stepNumber, this.form, this.isOffline, this.isGuest).then(response => {
                    if (response.project?.hasDifferenceVersion) {
                        ConflictSyn.show(response.index, response.project)
                    } else {
                        this.redirection()
                    }
                }).catch(err => {
                    this.redirection()
                })
            },
            redirection(){
                const index = this.$route.params.index
                this.$router.push({name: this.urlNextProject, params: {index}})
            }
        }
    }
</script>

<style lang="stylus" scoped>
</style>